export default __webpack_public_path__ + "static/media/nicolasrage.1a25b5c3.png";